import React from "react";
import styles from "./Banner.module.css";

function Banner() {
  return (
    <div className={styles.container}>
      <p></p>
      <p></p>
    </div>
  );
}

export { Banner };
